import { useAuthContext } from './agencyAuthHook'
import { useNavigate } from 'react-router-dom'

export default function LogoutHook() {
const {dispatch}=useAuthContext()
const navigate = useNavigate()

// learner logout
const agencyLogout=()=>{
  if (window.confirm('Are you sure you want to Logout?')){
      setTimeout(() => {
        navigate("/")
        localStorage.removeItem('agency')
        sessionStorage.removeItem('agency')
      }, 10);
      dispatch({ type: "AGENCY_LOGOUT" }); 
  }
   
    }
  
  return {agencyLogout}
}
